import { useQuery } from "@tanstack/react-query";
import { useTenant } from "modules/tenant/providers/tenant-provider";
import { api } from "utils/api";

export interface BorrowerCompanyForTheCompanyModel {
  id: string;
  name: string;
  address: string | null;
  logo: string | null;
}

const fetchBorrowerCompanies = async (): Promise<BorrowerCompanyForTheCompanyModel[]> => {
  const { data } = await api.get<BorrowerCompanyForTheCompanyModel[]>(`/tenant/borrower-companies`);

  return data;
};

export function useBorrowerCompaniesForTheTenant() {
  const { user } = useTenant();

  return useQuery({
    queryKey: ["borrower-companies", user.lender_company.id],
    queryFn: () => fetchBorrowerCompanies(),
    enabled: !!user.lender_company.id,
  });
}
